import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { json } from 'stream/consumers';
import { environment } from '../../../../environments/environment';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyServiceService {
  CompanyapiUrl = this.ConfigService.getAPIBaseUrl() + 'api/CompanyInformation/';
  AccPeriodapiUrl = this.ConfigService.getAPIBaseUrl() + 'api/AccountingPeriod/';
  UserUrl = this.ConfigService.getAPIBaseUrl() +'api/UserInformation/'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertCompany(data) {
    return this.http.post(this.CompanyapiUrl +'InsertCompanyInformation', data);
  }

  GetIsApprovedFlag(Email) {
    debugger
    return this.http.get(this.CompanyapiUrl + 'GetIsApprovedFlag?email=' + Email)

  }

  GettAllCompanyData(Name) {
    debugger
    return this.http.get(this.CompanyapiUrl + 'GettAllCompanyData/' + Name)
  }

  GetParticularCompanyDataBYNo(RegNo) {
    debugger
    return this.http.get(this.CompanyapiUrl + 'GetParticularCompanyData1/' + RegNo)
  }

  InsertApprovedFlag(email: string): Observable<number> {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    return this.http.post<number>(this.CompanyapiUrl + 'InsertApprovedFlag/' + email,

      httpOptions);

  }
 
  InsertDeclinedFlag(email: string): Observable<number> {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    return this.http.post<number>(this.CompanyapiUrl + 'InsertDeclinedFlag/' + email,

      httpOptions);

  }


  getAllCompanies(id) {
    return this.http.get(this.CompanyapiUrl + 'GetAllCompanyInformations?UserId=' + id);
  }

  getCompany(id) {
    return this.http.get(this.CompanyapiUrl + 'GetCompanyInformation?CompanyId=' + id);
  }

  deleteCompany(id) {
    return this.http.post(this.CompanyapiUrl + 'DeleteCompanyInformation?CompanyId=' + id,'');
  }

  insertAccPeriod(data) {
    return this.http.post(this.AccPeriodapiUrl + 'InsertAccountingPeriodDetails', data);
  }

  getAllAccPeriod(id) {
    return this.http.get(this.AccPeriodapiUrl + 'GetAccountingPeriodDetails?CompanyId=' + id);
  }

  getAccPeriod(id) {
    return this.http.get(this.AccPeriodapiUrl + 'GetAccountingPeriodbyId?AccPeriodid=' + id);
  }

  deleteAccPeriod(id) {
    return this.http.post(this.AccPeriodapiUrl + 'DeleteAccountigPeriod?AccPeriodid=' + id, '');
  }
  getLoginDetails(EmailId) {
    debugger
    return this.http.get(this.UserUrl + 'GetLoginByEmail?EmailId=' + EmailId);
  }
  UpdateShowStartHeretatus(id: string): Observable<number> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<number>(this.UserUrl + 'UpdateShowStartHereStatus/' + id,
      httpOptions);
  }
  UpdateShowStartHeretatusClose(id: string): Observable<number> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<number>(this.UserUrl + 'UpdateShowStartHereStatusClose/' + id,
      httpOptions);
  }
  Chart_of_Accounts_Report() {
    return this.http.get(this.CompanyapiUrl + 'Chart_of_Accounts_Report');
  }
  InsertLoginHistory(data) {
    debugger
    //data = JSON.stringify(data)
    //data = JSON.parse(data)
    //const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post(this.UserUrl + 'InsertLoginHistory', data)
  }
  getUserLoginhistroy(id) {
    debugger
    return this.http.get(this.UserUrl + 'GetLoginHistory?id=' + id);
  }
  DeleteMultipleUserLoginHistory(ids) {
    const indexes = JSON.stringify({ "ids": ids });
    let headers = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
      })
    }

    return this.http.post(this.UserUrl + 'DeleteLoginHistory', indexes, headers);
  }


  public APPeriodId = new BehaviorSubject<number>(0);
  getAPPeriodId = this.APPeriodId.asObservable();

  setAPPeriodId(value) {
    this.APPeriodId.next(value);
  }
}
